import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentService } from '../../store/services/content.service';
import { LeftMenuService } from '../../store/services/left-menu.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Button,
  ButtonColor,
  ButtonSize,
} from '../../store/models/button.model';

@Component({
  selector: 'app-edit-vsm-comments',
  templateUrl: './edit-vsm-comments.component.html',
  styleUrls: ['./edit-vsm-comments.component.scss'],
})
export class EditVsmCommentsComponent implements OnInit {
  state: 'edit' | 'create';
  responseId: number;
  formGroup: FormGroup;
  ready: boolean;
  error: { name?: string; response?: string };

  cancelButtonProperties: Button = {
    size: ButtonSize.SMALL,
    color: ButtonColor.BLUE,
    text: 'Cancel',
    onClick: () => this.router.navigate(['/contents/vsm_comments']),
  };

  saveButtonProperties: Button = {
    size: ButtonSize.SMALL,
    color: ButtonColor.ORANGE,
    onClick: () => this.saveOrUpdateResponse(),
    text: null,
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private leftMenuService: LeftMenuService
  ) {}

  ngOnInit(): void {
    this.leftMenuService.expand('content');
    this.state = this.activatedRoute.snapshot.data.state;

    if (this.state === 'edit') {
      this.responseId = this.activatedRoute.snapshot.params.id;
      this.contentService
        .getVsmComment(this.responseId)
        .subscribe(responseData => {
          this.initializeForm(responseData.name, responseData.response);
        });
    } else {
      this.initializeForm();
    }
  }

  initializeForm(name = '', response = '') {
    this.formGroup = new FormGroup({
      name: new FormControl(name, [Validators.required]),
      response: new FormControl(response, [Validators.required]),
    });

    this.ready = true;
  }

  get response() {
    // remove <p> and </p> tags
    return this.formGroup.get('response').value.replace(/<\/?p[^>]*>/g, '');
  }

  saveOrUpdateResponse() {
    if (this.formGroup.valid) {
      if (this.state === 'create') {
        this.contentService
          .createVsmComment(this.formGroup.get('name').value, this.response)
          .subscribe(
            () => this.router.navigate(['contents', 'vsm_comments']),
            error => this.formatError(error)
          );
      } else {
        this.contentService
          .updateVsmComment(
            this.responseId,
            this.formGroup.get('name').value,
            this.response
          )
          .subscribe(
            () => this.router.navigate(['contents', 'vsm_comments']),
            error => this.formatError(error)
          );
      }
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  formatError(error: HttpErrorResponse) {
    if (error && error.error) {
      let eMessage = null;
      try {
        eMessage = JSON.parse(error.error.message);
      } catch (e) {
        console.log('Could not parse error object:', error.error.message);
      }

      if (eMessage) {
        Object.keys(eMessage).forEach(key => {
          if (!this.error) {
            this.error = {
              [key]: null,
            };
          }

          this.error[key] = eMessage[key][0];
        });
      }
    }
  }

  getSaveButtonText() {
    return this.state === 'create' ? 'Create' : 'Save';
  }
}
